<template>
  <zen-one :showuserinfo="true" :title="'Direktori Admin'">
<z-page class="white--bg mt3 sh2" :title="'Paparan Senarai Direktori Admin'" >
  <div class="w-card__content content-hardcode mb3">
        <w-form v-model="valid" @validate="cari" ref="frm">
          <w-flex class="mt3">
            <w-input style="margin:5px;" class="mt4" v-model="carian_admin.name" label="Nama Admin" />
            <z-select style="margin:5px;" v-model="carian_admin.lkp_negeri_id" :items="lkp_negeri" label="Negeri" />
          </w-flex>
        </w-form>
        <w-flex justify-end class="mt2">
          <w-button class="mr2" v-on:click="resetPencarianAdmin()" bg-color="warning">
            <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA
          </w-button>
          <w-button class="mr2" bg-color="primary" @click="setCarianAdmin()">
            <w-icon>fal fa-search</w-icon>&nbsp;CARI
          </w-button>
        </w-flex>
      </div>
    <div class="admin-scrol">
      <div v-if="admin_datas.data && admin_datas.data.length === 0" class="no-records">
            <h3>Tiada Rekod Ditemukan</h3>
          </div>
         <div class="dashboard2">
            <div class="cardaiman" v-for="(dt, index) in admin_datas.data" >
               <div class="card-infoadmin">
               <span><h2> {{ dt.label }}</h2></span>
            </div>
      <w-flex class="flex justify-end">
        <w-image
            class="maa sh1 bdrsr d-block"
            :src="dt.avatar"
            style="width: 57px;height: 57px;margin-top: -93px;margin-right: -5px;"
            >
        </w-image> 
      </w-flex>
            <div class="card-infoadmin">
               <span style="color: red"><h1> {{ dt.role }}</h1></span>
            </div>
                 <!-- <w-tag class="mr4" bg-color="white" round><h2>{{ dt.label }}</h2></w-tag> -->
                   <!-- </div> -->
                   <div class="card-infoadmin">
                   <span style="color: black"><p> {{ dt.email }}</p></span>
                   <span style="color: black "><p> {{ dt.no_tel }}</p></span>
                   <span style="color: black"><p> {{ dt.negeri }}</p></span>
                   <span style="color: black"><p> {{ dt.cawangan }}</p></span>
                </div>
              </div>
          </div>
       </div>
       <w-flex v-if="admin_datas.data && admin_datas.data.length > 0" justify-end class="mt2 pagination-container">
           <template v-for="(link, index) in admin_datas.links" :key="index">
             <w-button
               bg-color="grey-light5--bg"
               class="pagination-button"
               :class="{ active: link.active }"
               @click="pageAdmin(link)"
               :disabled="!link.url || link.active"
             >
               {{ link.label }}
             </w-button>
           </template>
         </w-flex>
   </z-page>
  </zen-one>|
</template>
<script>
export default {
props: {
    auth: [Array, Object],
},
components: {
    
},
data() { return {
  errors: [],
  admin_datas : [],
  carian_admin: {
         name: '',
         lkp_negeri_id: '',
      },
  cari_admin: {
         name: '',
         lkp_negeri_id: '',
      },
   lkp_negeri: [],


  
  crumbs: [
    { label: this.$page.props.app_name, route: '/direktori_admin' },
  ],
  tahun:[],
  

}},
methods: {


  

   getNegeri(){
      this.$zcomm.get(this.api_service + 'lookup/negeri_aiman', {}).then(res => {
        this.lkp_negeri = res
      })
    },

    resetPencarianAdmin() {
      this.carian_admin.lkp_negeri_id = ''
      this.carian_admin.name = ''
      this.setCarianAdmin()
    },

    setCarianAdmin() {
      this.cari_admin.lkp_negeri_id = this.carian_admin.lkp_negeri_id
      this.cari_admin.name = this.carian_admin.name
      this.getadminSenarai(1)
    },

     getadminSenarai(page){
         this.$zcomm.get(this.api_service + 'lookup/admin_senarai?name='+this.cari_admin.name+'&lkp_negeri_id='+ this.cari_admin.lkp_negeri_id+'&page='+page, {}).then(res => {
           this.admin_datas = res
         })
     },

     pageAiman(link) {
    if (!link.url || link.active) return;
    
    let page;
    
    switch(link.label) {
      case 'Seterusnya':
        page = this.admin_datas.current_page + 1;
        break;
      case 'Sebelum':
        page = this.admin_datas.current_page - 1;
        break;
      default:
        // Untuk angka halaman (1, 2, 3, dst)
        page = parseInt(link.label);
    }
    
    if (page) {
      this.getadminSenarai(page);
    }
  },

   
 
  
},

mounted() {
  this.getadminSenarai()
  this.getNegeri()
    
    
}
}

</script>

<style>
.w-card {
    z-index: 9;
}

.dashboard2 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 70px;
  padding: 20px;
  background-color: #f5f5f5;
}

.cardaiman:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  justify-content: center;
}

.cardadmin:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  justify-content: center;
}

.cardaiman {
  /*background: linear-gradient(135deg, #0abedf, #478ed1), url(/images/bingkai.png) center / cover no-repeat;*/
  background: url(/images/admin12.png) center / cover no-repeat;
  border-radius: 15px;
  box-shadow: -10px 16px 14px 4px rgb(0 0 0 / 17%);
  padding: 20px;
  width: 400px;
  height: 250px;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;


}

.card-infoadmin h2 {
  margin-top: 47px;
  margin-left: -10px;
  font-size: 14px;
  font-family: "Gill Sans Extrabold", sans-serif;
  padding: 5px;
  font-weight: bold;
  color: white;
  letter-spacing: 1px;

}

.no-records {
  text-align: center;
  padding: 50px;
  font-size: 18px;
  color: #666;
  background-color: #f5f5f5;
  border-radius: 10px;
  margin: 20px;
}

.card-infoadmin h1 {
  margin-top: 8px;
  margin-left: 30px;
  font-size: 14px;
  font-family: "Gill Sans Extrabold", sans-serif;
  padding: 5px;
  font-weight: bold;
  color: #204288;

}

.card-infoadmin p {
  font-size: 13px;
  font-weight: bold;
  color: black;
  margin-top: 7px;
  padding-top: 2px;
  margin-left: 10px;
}


</style>
